import { UPDATE_AUTH, ADD_ROOFTOP_OPTIONS } from 'reducers/authReducers'

import Amplify, { Hub, Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import axios from 'axios'

import { GET } from 'actions/apiActions'

import { OAUTH } from 'cognito'
import API_ENDPOINTS from 'endpoints'
import { getEnvName } from 'config/env.js'

import { getRooftopId, isHelix } from 'selectors/appStatusSelectors'
import { getRooftop, tagCustomer } from 'actions/appStatusActions'
import { goTo, redirect } from 'actions/pageStateActions'
import { tagDealerUser } from 'actions/naughtyActions'
import { warn } from 'utils'
import { getUserIdToken, getUserToken } from 'selectors/authSelectors'

export const updateAuth = (shovel = true) => async (dispatch, getState) => {
    // TODO vet all this data, we probably don't need all of it
    // TODO this is becoming the 'boostrap app' action

    return Auth.currentSession()
      .then(() => dispatch(updateCognitoUser()))
      .then(() => dispatch(updateUserData()))
      .then(() => dispatch(tagDealerUser()))
      .then(() => dispatch(enumerateRooftopsForUser()))
      .then(() => getRooftopId(getState()) && dispatch(getRooftop()))
      .catch(e => {
        warn('Update user failed', e)
      })
      .then(() =>
        dispatch({
          type: UPDATE_AUTH,
          payload: { loginChecked: true },
        }),
      )
      .then(() => shovel && dispatch(shovelToken()))
  },
  shovelToken = () => (dispatch, getState) => {
    dispatch({ type: 'SHOVEL_TOKEN' })

    let tokens = {
        idToken: getUserIdToken(getState()),
        accessToken: getUserToken(getState()),
      },
      axiosOptions = {
        method: 'POST',
        data: tokens,
        url: '/htmx/login',
        headers: { 'content-type': 'application/json' },
        validateStatus: () => true,
      }

    if (!tokens.idToken || !tokens.accessToken) return

    axios(axiosOptions).then(r => {
      if (r.status !== 200) dispatch(signOut())
    })
  },
  invalidateToken = () => (dispatch, getState) => {
    dispatch({ type: 'INVALIDATE_TOKEN' })

    let tokens = {
        idToken: getUserIdToken(getState()),
        accessToken: getUserToken(getState()),
      },
      axiosOptions = {
        method: 'POST',
        data: tokens,
        url: '/htmx/logout',
        headers: { 'content-type': 'application/json' },
        validateStatus: () => true,
      }

    axios(axiosOptions).then(() => Auth.signOut())
  },
  updateCognitoUser = () => async dispatch => {
    return Auth.currentAuthenticatedUser()
      .then(cognitoUser => {
        dispatch({ type: UPDATE_AUTH, payload: { cognitoUser } })
      })
      .catch(
        () => dispatch({ type: UPDATE_AUTH, payload: { cognitoUser: null } }),
        dispatch(tagCustomer()),
      )
  },
  globalSignout = () => dispatch => {
    Auth.currentAuthenticatedUser().then(cognitoUser => {
      cognitoUser && cognitoUser.globalSignout(() => {}, () => {})
      dispatch(redirect('/'))
    })
  },
  updateUserData = () => dispatch => {
    return dispatch(GET.userData()).then(userData => {
      dispatch({ type: UPDATE_AUTH, payload: { userData } })
    })
  },
  setupAuthWatcher = () => dispatch => {
    let logger = new Logger('iq-logger')

    const listener = data => {
      switch (data.payload.event) {
        case 'signIn':
          dispatch(updateAuth())
          break
        case 'signOut':
          let path =
            window.location.pathname !== '/'
              ? `/?d=${btoa(window.location.pathname)}`
              : `/`

          dispatch(redirect(path, true))
          break
        case 'tokenRefresh':
          logger.info('token refresh succeeded')
          break
        case 'tokenRefresh_failure':
          logger.error('token refresh failed')
          dispatch(signOut())
          break
        case 'configured':
          dispatch(updateAuth())
          break
        default:
          break
      }
    }

    Hub.listen('auth', listener)

    Amplify.configure({
      ...API_ENDPOINTS,
      Auth: OAUTH[getEnvName()],
    })

    Logger.LOG_LEVEL = window.LOG_LEVEL
  },
  enumerateRooftopsForUser = () => dispatch => {
    return dispatch(GET.availableRooftopsForUser()).then(roofOptions => {
      if (roofOptions) {
        return dispatch({ type: ADD_ROOFTOP_OPTIONS, payload: roofOptions })
      }
    })
  },
  signOut = () => dispatch => {
    dispatch(invalidateToken())
  }
